import { Badge } from 'react-bootstrap';

/**
 * Common component for rendering badges with optional emojis.
 * 
 * @param {string} value - The key to look up in colors and labels objects.
 * @param {Object} colors - Mapping of values to Bootstrap background colors.
 * @param {Object} labels - Mapping of values to label strings or { emoji, label } objects.
 * @returns {JSX.Element|string} - A Badge component or '-' if value is not found.
 */
export const StatusBadge = ({ value, colors, labels }) => {
  if (!value || !labels[value]) return '-';
  const color = colors[value] || 'secondary';
  const config = labels[value];
  const emoji = typeof config === 'object' ? config.emoji : null;
  const label = typeof config === 'object' ? config.label : config;
  
  return (
    <Badge bg={color} title={label} className="d-inline-flex align-items-center gap-1">
      {emoji && (
        <span style={{ fontSize: '1.3em', marginBottom: '0.1em' }}>
          {emoji}
        </span>
      )}
      <span>{label}</span>
    </Badge>
  );
};
